import { combineReducers } from "redux";
import {
  FETCH_EVENT,
  FETCH_INTERESTS,
  OPEN_INTEREST_MODAL,
  EDIT_INTEREST,
  FETCH_EVENTSETTINGS,
  LOGGEDINUSER_DATA,
} from "ActionsMessage";

export function eventReducers(state = [], action) {
  switch (action.type) {
    case FETCH_EVENT:
      return action.payload.resource;
    default:
      return state;
  }
}

export function InterestModalReducer(
  state = { status: false, interest: {} },
  action
) {
  switch (action.type) {
    case OPEN_INTEREST_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function InterestsReducers(state = [], action) {
  switch (action.type) {
    case FETCH_INTERESTS:
      return action.payload.resource;
    default:
      return state;
  }
}

export function EditInterestReducers(state = {}, action) {
  switch (action.type) {
    case EDIT_INTEREST:
      return action.payload;
    default:
      return state;
  }
}

export function eventSettingsReducers(state = [], action) {
  switch (action.type) {
    case FETCH_EVENTSETTINGS:
      return action.payload.resource;
    default:
      return state;
  }
}

export function loggedinuserData(state = [], action) {
  switch (action.type) {
    case LOGGEDINUSER_DATA:
      return action.payload;
    default:
      return state;
  }
}
